export const RELOAD_LIST_ACTION = '[LIST] Reload';

export const ReloadListAction = (payload, entity = '') => ({
    type: RELOAD_LIST_ACTION + (entity ? (' ' + entity) : ''),
    payload,
    entity
});
